{
  "vibes": {
    "quietEnergy": "Quiet Energy",
    "openToChat": "Open To Chat",
    "newHere": "New Here",
    "studyMode": "Study Mode",
    "coffeeLover": "Coffee Lover",
    "lookingAround": "Just Looking Around",
    "deepConversations": "Deep Conversations",
    "lightConversations": "Light Conversations"
  },
  "modes": {
    "meet": {
      "title": "Meet People",
      "subtitle": "Make a new connection nearby"
    },
    "work": {
      "title": "Study / Work Alongside",
      "subtitle": "Company without pressure"
    },
    "networking": {
      "title": "Networking",
      "subtitle": "Find people in your field"
    },
    "language": {
      "title": "Language Practice",
      "subtitle": "Practice with locals"
    },
    "curious": { "title": "Just Curious", "subtitle": "See who is around" }
  },
  "friendshipGoals": {
    "makeNewFriends": "Make New Friends",
    "buildCloseFriendships": "Build Close Friendships",
    "findActivityPartners": "Find Activity Partners",
    "haveCasualChats": "Have Casual Chats",
    "joinSmallGroups": "Join Small Groups",
    "findCommunity": "Find Community",
    "buildSocialConfidence": "Build Social Confidence",
    "seeWhatHappens": "See What Happens",
    "other": "Other"
  },
  "gender": {
    "woman": "Woman",
    "man": "Man",
    "nonBinary": "Non-binary",
    "other": "Other",
    "preferNotToSay": "Prefer not to say",
    "custom": "Custom"
  },
  "religion": {
    "christian": "Christian",
    "muslim": "Muslim",
    "jewish": "Jewish",
    "hindu": "Hindu",
    "buddhist": "Buddhist",
    "spiritual": "Spiritual",
    "agnostic": "Agnostic",
    "atheist": "Atheist",
    "other": "Other",
    "preferNotToSay": "Prefer not to say"
  },
  "politics": {
    "liberal": "Liberal",
    "moderate": "Moderate",
    "conservative": "Conservative",
    "independent": "Independent",
    "notPolitical": "Not political",
    "preferNotToSay": "Prefer not to say"
  },
  "languages": {
    "english": "English",
    "spanish": "Spanish",
    "french": "French",
    "arabic": "Arabic",
    "portuguese": "Portuguese",
    "german": "German",
    "italian": "Italian",
    "mandarin": "Mandarin",
    "hindi": "Hindi",
    "yoruba": "Yoruba",
    "igbo": "Igbo",
    "hausa": "Hausa",
    "irish": "Irish",
    "polish": "Polish",
    "ukrainian": "Ukrainian",
    "russian": "Russian",
    "turkish": "Turkish",
    "japanese": "Japanese",
    "korean": "Korean",
    "vietnamese": "Vietnamese",
    "other": "Other"
  }
}
